// extracted by mini-css-extract-plugin
export var card = "banner-module--card--44b55";
export var gridColumn = "banner-module--gridColumn--1f495";
export var group = "banner-module--group--883fa";